export const SUPPORT_MESSAGES_SIZE = 30
